var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tbody',[_vm._l((_vm.aimItems),function(aimItem,aimIndex){return _vm._l((_vm.uniqBy(
        _vm.filterItemsBy(_vm.items, {
          aim: aimItem.aim,
        }),
        'stakeholder'
      )),function(stakeholderItem,stakeholderIndex){return _c('tr',{key:`stakeholder-${stakeholderIndex}-${aimIndex}`},[(aimIndex === 0 && stakeholderIndex === 0)?_c('td',{attrs:{"criterion":"","rowspan":_vm.uniqBy(
            _vm.filterItemsBy(_vm.items, {
              criterion: aimItem.criterion,
            }),
            'stakeholder'
          ).length * _vm.aimItems.length}},[_c('a',{attrs:{"name":`${_vm.property}`,"id":_vm.property}}),_c('text-highlight',{staticClass:"inline-block",attrs:{"queries":[_vm.state.searchInput]}},[_vm._v(_vm._s(_vm.property))])],1):_vm._e(),(stakeholderIndex === 0)?_c('td',{attrs:{"aim":"","rowspan":_vm.uniqBy(
            _vm.filterItemsBy(_vm.items, {
              aim: aimItem.aim,
            }),
            'stakeholder'
          ).length}},[_c('span',[_vm._v(_vm._s(_vm.getAimById(aimItem.aim).name))])]):_vm._e(),_c('td',{attrs:{"stakeholder":""}},[_c('b',[_vm._v(_vm._s(_vm.getStakeholderName(stakeholderItem.stakeholder)))])]),_vm._l((_vm.c_alternativesIds),function(alternativeId,alternativeIndex){return _c('td',{key:alternativeIndex,staticClass:"text-center",attrs:{"alternative":""}},[_c('Acceptability',{attrs:{"items":_vm.filterItemsBy(_vm.items, {
              alternative: alternativeId,
              aim: aimItem.aim,
              stakeholder: stakeholderItem.stakeholder,
            }),"alternative":alternativeId}})],1)})],2)})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }